/** Поддомены порталов: видимость только при meta.desk_show_portal_* в админке. */
export const EMPLOYEE_DESK_EXTERNAL_PORTALS = [
  {
    id: 'portal_grab',
    prefKey: 'desk_show_portal_grab',
    label: 'Grab — портал',
    href: 'https://grab.alex-digital.io/',
  },
  {
    id: 'portal_gojek',
    prefKey: 'desk_show_portal_gojek',
    label: 'Gojek',
    href: 'https://gojek.alex-digital.io/',
  },
  {
    id: 'portal_qr',
    prefKey: 'desk_show_portal_qr',
    label: 'QR — дашборд',
    href: 'https://qr.alex-digital.io/',
  },
] as const
